export default ($axios) => ({
  fetchDepartments(query) {
    return $axios.get('/departments', { params: query }).then((response) => response.data);
  },
  fetchUser(userId) {
    return $axios.get(`/users/${userId}`).then((response) => response.data);
  },
});
